













































































































































































import Vue from 'vue';
import VatsAPI from '@/Shared/VatsAPI';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { HandheldUser } from './HandheldUser';
import { getValidationErrors } from '@/Shared/ValidationErrorDirective';
import mixins from 'vue-typed-mixins';
import RadioToggle from '@/Shared/RadioToggle.vue';

const HandheldUserAdmin = mixins(LocationBasedMixin).extend({
  components: { RadioToggle },
  data() {
    return {
      editUser: ({ isAddUser: false } as any) as HandheldUser,
      addUser: ({ isAddUser: true } as any) as HandheldUser,
      detailsUserID: null as string | null,
      handheldUsers: [] as HandheldUser[],
      loadingUsers: {} as { [userID: string]: boolean },
      validationErrors: {} as { [key: string]: string[] }
    };
  },
  methods: {
    toggleDetails(userID: string) {
      if (this.detailsUserID === userID) {
        this.detailsUserID = null;
      }
      else {
        this.detailsUserID = userID;
      }
    },
    editing(user: HandheldUser) {
      if ((user as any).isAddUser) {
        return true;
      } else if (
        this.editUser &&
        this.editUser.userID &&
        !(this.editUser as any).isAddUser
      ) {
        return this.editUser.userID === user.userID;
      } else {
        return false;
      }
    },
    edit(user: HandheldUser) {
      this.editUser = { ...user };

      // if this is a falsy value, set explicitly to false
      if (!this.editUser.isPEO) {
        this.editUser.isPEO = false;
      }
      if (!this.editUser.syncWithHandheld) {
        this.editUser.syncWithHandheld = false;
      }
    },
    add() {
      this.editUser = { ...this.addUser };

      // if this is a falsy value, set explicitly to false
      if (!this.editUser.isPEO) {
        this.editUser.isPEO = false;
      }
      if (!this.editUser.syncWithHandheld) {
        this.editUser.syncWithHandheld = false;
      }
    },
    async save(user: HandheldUser) {
      Vue.set(this.loadingUsers, user.userID, true);
      try {
        if ((user as any).isAddUser) {
          await VatsAPI.post(
            `/${this.location}/HandheldAdmin/AddHandheldUser`,
            user
          );
        } else {
          await VatsAPI.post(
            `/${this.location}/HandheldAdmin/UpdateHandheldUser`,
            user
          );
        }

        await this.refreshUsers();
      } catch (e) {
        this.validationErrors = getValidationErrors(e.response);
        throw e;
      } finally {
        Vue.set(this.loadingUsers, user.userID, false);
      }

      this.cancelEdit();
    },
    async deleteUser(user: HandheldUser) {
      const deleteConfirmMessage =
        this.$i18n.t('admin.handheldUsers.deleteConfirmMessage').toString() +
        `, ${user.userID}?`;
      const deleteConfirmTitle = this.$i18n
        .t('admin.handheldUsers.deleteConfirmTitle')
        .toString();
      const deleteButton = this.$i18n.t('common.delete').toString();
      const cancelButton = this.$i18n.t('common.cancel').toString();

      const confirmDelete = await this.$bvModal.msgBoxConfirm(
        deleteConfirmMessage,
        {
          title: deleteConfirmTitle,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          cancelVariant: 'info',
          okTitle: deleteButton,
          cancelTitle: cancelButton,
          centered: true
        }
      );

      if (confirmDelete) {
        try {
          Vue.set(this.loadingUsers, user.userID, true);
          await VatsAPI.post(
            `/${this.location}/HandheldAdmin/DeleteHandheldUser`,
            user
          );
          await this.refreshUsers();
          Vue.set(this.loadingUsers, user.userID, false);
        } catch (e) {
          this.$bvToast.toast(
            this.$i18n.t('admin.handheldUsers.deleteUserError').toString(),
            {
              title: this.$i18n.t('common.error').toString(),
              autoHideDelay: 5000
            }
          );
          throw e;
        }
      }
    },
    cancelEdit() {
      this.editUser = ({ isAddUser: false } as any) as HandheldUser;
      this.addUser = ({ isAddUser: true } as any) as HandheldUser;
    },
    async refreshUsers() {
      try {
        this.handheldUsers = (
          await VatsAPI.get<HandheldUser[]>(
            `/${this.location}/HandheldAdmin/GetHandheldUsers`
          )
        ).data;
      } catch (e) {
        this.$bvToast.toast(
          this.$i18n.t('admin.handheldUsers.refreshUserError').toString(),
          {
            title: this.$i18n.t('common.error').toString(),
            autoHideDelay: 5000
          }
        );
        throw e;
      }
    },
    async locationChanged() {
      await this.refreshUsers();
    }
  },
  async mounted() {
    this.refreshUsers();
  }
});

export default HandheldUserAdmin;
